document.addEventListener("DOMContentLoaded", function () {
  // Get the service dropdown and VDI dropdown elements
  var serviceDropdown = document.querySelector(
    'select[data-option-name="carrier-monthly-service-fee-and-processing-rate"]'
  );
  var vdiDropdown = document.querySelector("#do-you-want-vdi-set-up");

  if (serviceDropdown && vdiDropdown) {
    // Initial check
    var selectedOption = serviceDropdown.value;
    if (selectedOption.includes("Cashless Plus")) {
      // Set VDI to "Yes" and remove "No" option
      vdiDropdown.value = "Yes";
      $("#do-you-want-vdi-set-up option[value='No']").hide();
      $("#vdi-setup").attr("value", "");
      $("#vdi-setup").attr("name", "properties[VDI Setup]");
    }

    // On change event
    serviceDropdown.addEventListener("change", function () {
      var selectedOption = serviceDropdown.value;
      if (selectedOption.includes("Cashless Plus")) {
        // Set VDI to "Yes" and remove "No" option
        vdiDropdown.value = "Yes";
        $("#do-you-want-vdi-set-up option[value='No']").hide();
        $("#vdi-setup").attr("value", "");
        $("#vdi-setup").attr("name", "properties[VDI Setup]");
      } else {
        // Show "No" option again and set to "No"
        $("#do-you-want-vdi-set-up option[value='No']").show();
        vdiDropdown.value = "No";
        $("#vdi-setup").removeAttr("name");
      }
    });
  }
});
